import { FunctionComponent, ReactNode } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export interface DragDropManagerProps {
  children: ReactNode;
}

const DragDropManager: FunctionComponent<DragDropManagerProps> = ({
  children
}: DragDropManagerProps) => {
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
};

export default DragDropManager;
